import {omit} from 'external/lodash'
import {Link, forwardRef} from 'external/react'

const LinkBehavior = forwardRef(
  (props, ref) => (
    <Link
      ref={ref}
      to={`${props.groupId}/${props.target}`}
      {...omit(props, ['groupId', 'target'])}
    />
  )
)

export {LinkBehavior as default}
